import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	// const base64String = await pathToBase64(`/images/custom/flower/theme.png`)
	const background = await getBackground(data?.customTheme, 'theme')
	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "UnqAyGNMsx",
				"width": 653.38,
				"height": 137.34375,
				"left": 85.97,
				"top": 164.29,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 117.35px;\"><span style=\"font-family: 日本青柳衡山毛笔字体;\"><span style=\"color: rgba(61,179,169,1);\">${title}</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},


		],
		background
	};
}